module.exports = __webpack_public_path__ + "assets/img/sys-error.a17e8b8f.png";